import * as constAction from 'root/actionConstants';

export const asignar = values => ({
  type: constAction.ASIGNACION_ASIGNAR,
  payload: values,
  epic: {
    url: 'viajes/asignar',
    method: 'POST'
  }
});

export const setState = ( payload ) => ({
  type: constAction.ASIGNACION_SET_STATE,
  payload: payload
});

export const clear = value => ({
  type: constAction.ASIGNACION_CLEAR,
  payload: value
});

export const seleccionarChofer = (query) => ({
  type: constAction.VEHICULOS_SELECCIONAR_CHOFER,
  payload: {
    rol: 'chofer',
    query: query ? query : undefined
  },
  epic: {
    url: 'usuarios/buscarPorRol',
    method: 'POST'
  }
});

export const seleccionarVehiculo = (query) => ({
  type: constAction.ASIGNACION_SELECCIONAR_VEHICULO,
  payload: {
    query: query ? query : undefined
  },
  epic: {
    url: 'vehiculos/buscar',
    method: 'GET'
  }
});



// WEBPACK FOOTER //
// src/modules/asignacion/action.js